import { useMutation } from "@apollo/client";
import { DocumentTextIcon } from "@heroicons/react/outline";
import { MenuItem } from "@szhsin/react-menu";

import { focusTopicEditorWhenReady } from "@apps/meeting-new/helpers";

import updateTopicMutation from "../graphql/update-topic-mutation";

const ToggleSharedNotesMenuItem = ({
  topic,
  meeting,
  ...props
}: {
  topic: any;
  meeting: any;
  meetingGroup?: any;
  currentPageMeeting?: any;
}) => {
  const [updateTopic] = useMutation(updateTopicMutation);

  if (topic.includesSharedNotes) return null;

  const handleInsertSharedNotes = async () => {
    // Wait for the mutation to settle before focusing the editor so the
    // focus call doesn't race the section's mount on slow connections.
    await updateTopic({
      variables: {
        topicId: topic.id,
        meetingId: meeting?.id,
        includesSharedNotes: true,
      },

      optimisticResponse: {
        createOrUpdateTopic: {
          topic: {
            ...topic,
            includesSharedNotes: true,
          },
        },
      },
    });
    focusTopicEditorWhenReady(
      topic.id,
      '[aria-label="Meeting topic shared notes"] .js-topic-discussion-notes-input',
    );
  };

  return (
    <MenuItem className="text-sm" onClick={handleInsertSharedNotes} {...props}>
      <DocumentTextIcon className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" />{" "}
      Show shared notes section
    </MenuItem>
  );
};

export default ToggleSharedNotesMenuItem;
